<template>
  <n-config-provider :theme-overrides="themeOverrides">
    <router-view />
  </n-config-provider>
</template>

<script setup lang="ts">
import { NConfigProvider } from 'naive-ui'
import type { GlobalThemeOverrides } from 'naive-ui'

const themeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: '#0058be',
    primaryColorHover: '#0047a0',
    primaryColorPressed: '#003880',
    primaryColorSuppl: '#0058be',
  },
  Button: {
    fontWeightStrong: '600',
  },
}
</script>
